import React, { Component } from "react";

import auth from "../services/authService";
import Table from "./common/table";
import Moment from "react-moment";
import { isBlockedShortCode } from "../utils/shortCodeStatus";
import CopyableText from "./common/copyableText";

class allDreamsTable extends Component {
  columns = [];


  render() {
    const { dreams, onSort, sortColumn, pcode } = this.props;
    const email = auth.getCurrentUser();
    if (
      email === "adib@salmustasharak.com" ||
      email === "mohannad@salmustasharak.com"
    ) {

      this.columns = [
        { path: "ReplyUserName", label: "المفسر" },
        { path: "PersonStatus", label: "الحالة" },

        {
          path: "MOShortCode",
          label: "رقم الشورت كود",
          content: (dream) => (
            <span>
              {dream.MOShortCode}{" "}
              {isBlockedShortCode(dream.MOShortCode) ? "❌" : "✅"}
            </span>
          ),
        },

        {
          path: "MT_Mobil",
          label: "رقم الموبايل",
          content: (dream) => <CopyableText value={dream.MT_Mobil} />,
        },

        { path: "MT_Reply_Msg", label: "الرد" },
        {
          path: "ReplyDate",
          label: " تاربخ الرد للرسالة",
          content: (dream) => (
            <Moment
              parse="YYYY-MM-DD HH:mm"
              format="YYYY-MM-DD hh:mm A"
              className="text-primary"
            >
              {dream.ReplyDate}
            </Moment>
          ),
        },
        { path: "MO_Message", label: "الرسالة المرسلة" },
        {
          path: "MO_Date",
          label: "تاريخ الرسالة",
          content: (dream) => (
            <Moment
              parse="YYYY-MM-DD HH:mm"
              format="YYYY-MM-DD hh:mm A"
              className="text-primary"
            >
              {dream.MO_Date}
            </Moment>
          ),
        },

        {
          path: "isdelete",
          label: "محذوف",
          content: (dream) =>
            dream.isdelete ? (
              <i className={"fa fa-trash  fa-lg text-danger"}></i>
            ) : (
              ""
            ),
        },
      ];



    }


    else {

      this.columns = [
        { path: "MT_Reply_Msg", label: "الرد" },


        { path: "MO_Message", label: "الرسالة المرسلة" },



        {
          path: "isdelete", label: "محذوف",
          content: dream => dream.isdelete ?
            <i className={"fa fa-trash  fa-lg text-danger"}>


            </i> : ''

        },
      ];



    }

    return (
      <Table
        columns={this.columns}
        data={dreams}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default allDreamsTable;



// WEBPACK FOOTER //
// ./src/components/allDreamsTable.jsx